import React from 'react';

const bookingRef = React.createContext({booking: null});

export default bookingRef;



// WEBPACK FOOTER //
// ./src/services/booking-ref.tsx